const t="action",o="state";export{t as dispatchEvent,o as stateEvent};
